<template>
  <v-app class="ErrorWrapper">
    <v-content>
      <div class="flex centered fill-height">

        <div class="box corset elevation-9">
          <div class="huge">
            ¯\_(ツ)_/¯
          </div>
          <br/>
          <h1 class="bold">Seite nicht gefunden!</h1>
          <br/>
          <p class="loud">Haben Sie sich eventuell vertippt, oder einen sehr alten Link aufgrufen?</p>
          <br/>
          <hr class="seventy">
          <div class="brow justify-content-center">
            <div :class="linkCol()">
              <router-link :to="{ name: 'home', params: {} }" class='box big-icn elevation-2'>
                <i class="icon-home"></i>
                StartSeite
              </router-link>
            </div> 
          </div>
        </div>
        
          
        
      </div>
      

    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
// import StieblingLogo from '@/components/AppLogo'

export default {
  name: 'NotFound',
  components: {
    // AppLogo
  },
  methods: {
    linkCol() {
      return "col-6 col-sm-4 col-md-3 col-lg-2"
    }
  }
}
</script>
<style lang="scss">
  #main-content.home {
    background: #f3f3f3;
  }
  .huge {
    font-size: 80px;
    font-family: mono, mono;
    color: #1961AC;
    text-shadow: 0 1px 1px #fff;
  }
  .application.ErrorWrapper {
    background: transparent url('../assets/images/sports_blur.png') left top repeat !important;
  }
</style>
